export const POST_CREATE_PAYMENT = "POST_CREATE_PAYMENT"
export const POST_SUCCESS_PAYMENT = "POST_SUCCESS_PAYMENT"
export const POST_UPDATE_PROVIDER = "POST_UPDATE_PROVIDER"